module.exports = __webpack_public_path__ + "static/media/SUPPORTER.38d2af34.svg";